import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3108b12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]

interface Props {
  count?: string;
  contrast?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDot',
  props: {
    count: { default: '0' },
    contrast: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notificationDotWrapper", {contrast: _ctx.contrast}])
  }, [
    _createElementVNode("div", {
      class: "notificationDot",
      textContent: _toDisplayString(_ctx.count)
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})